import { defineComponent as _defineComponent } from 'vue'
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import { computed, PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMessengerConfirm',
  props: {
  value: {
    type: Boolean
  },
  yesLabel: {
    type: String,
    default: ''
  },
  noLabel: {
    type: String,
    default: ''
  },
  okType: {
    type: String as PropType<'' | 'ok' | 'warning' | 'primary'>,
    default: ''
  },
  enableConfirm: {
    type: Boolean,
    default: true
  }
},
  emits: ['input', 'confirm'],
  setup(__props, { emit }) {

const props = __props;





const colorVar = computed(() => {
  switch (props.okType) {
    case 'warning': return 'var(--foreground-color--warning-intense)';
    case 'ok': return 'var(--foreground-color--ok)';
    case 'primary': return 'var(--primary-color)';
    default: return '';
  }
});

const confirm = (which: boolean) => {
  emit('input', false);
  emit('confirm', which);
};

return { __sfc: true,props, emit, colorVar, confirm, BCXIcon }
}

})